/**
 * Memory Data Adapter
 *
 * Loads Memory detail data and merges with pricing data from separate files.
 * Uses the generic adapter pattern for consistency.
 */

import type { MemoryModel } from '../../models/memory/memory-model'
import { createSingletonAdapter, type GenericDataAdapter } from '../common/GenericDataAdapter'

// Create singleton instance using generic adapter
const { getAdapter, resetAdapter } = createSingletonAdapter<MemoryModel>({
  basePath: '/data/memory',
  componentName: 'memory'
})

/**
 * Get the singleton instance of MemoryDataAdapter
 */
export function getMemoryDataAdapter(): GenericDataAdapter<MemoryModel> {
  return getAdapter()
}

/**
 * Reset the singleton instance (useful for testing)
 */
export function resetMemoryDataAdapter(): void {
  resetAdapter()
}

// Re-export for backward compatibility
export type MemoryDataAdapter = GenericDataAdapter<MemoryModel>
